import { useTruncate } from '../../utils/truncateString';

export const TruncateString = ({ text, textLength }: { text: string; textLength?: number }) => {
  const dottedString = useTruncate(text, textLength);

  return <>{dottedString}</>;
};
